<template>
	<div>
		<b-modal id="modal-input" scrollable :no-close-on-backdrop=true :title="'Advance Filter'" :no-close-on-esc=true v-model="isFilterShow"
				 :dialog-class="''"
				 :ok-title="'Search'"
				 ok-variant="success"
				 :cancel-title="'Clear'"
				 @ok="getReportSummaryNGs"
				 @hidden="resetModal">
			<b-card>
				<b-row>
					<b-col cols="12" lg="6">
						<app-input-datepicker id="fieldset-period-from" label-cols-lg="12"  
							label="Periode" size="sm" :model.sync="filter.filterPeriodFrom" 
							:date-format-options="{ year: 'numeric', month: '2-digit', day: '2-digit' }" 
							locale="en-GB"  reset-button/>
					</b-col>
					<b-col cols="12" lg="6">

						<b-button variant="danger" v-if="false" size="sm" class="float-right" @click="resetFilter"><span style="font-size: 0.75rem" class="mr-1"><b-icon-x></b-icon-x></span> Clear Filter</b-button>
						<b-button variant="primary" v-if="false" size="sm" class="float-right mr-1" @click="getReportSummaryNGs"><span style="font-size: 0.75rem" class="mr-1"><b-icon-search></b-icon-search></span> Cari</b-button>
					</b-col>
				</b-row>
			</b-card>
			<template #modal-footer="{ ok }">
				<b-button size="sm" class="btn-default-white float-right" @click="resetFilter()">
					Clear
				</b-button>
				<b-overlay :show="isDataLoading"
						   rounded
						   opacity="0.6"
						   spinner-small
						   spinner-variant="primary"
						   class="float-right ">
					<b-button size="sm" class="float-right btn-default" @click="ok()">
						Search
					</b-button>
				</b-overlay>
			</template>
		</b-modal>

		<div>
			<b-row class="mb-2 d-sm-none d-md-flex">
				<b-col class="pt-1">
					<span class="function-title">Report Summary NG</span>
				</b-col>
				<b-col>
					<Portal to="app-navbar-bottom">
						<span class="float-right">
						</span>
					</Portal>
				</b-col>
			</b-row>
			<div class="table-corner">
				<div class="table-action-button">
					<b-button class="btn-action d-sm-none d-md-inline" size="sm" @click="downloadData"><b-icon-download class="mr-1"></b-icon-download> Download All To Excel</b-button>
					<b-button v-if="isShowAdvanceFilterButton" class="btn-action" size="sm" @click="isFilterShow = true"><b-icon-search class="mr-1"></b-icon-search> {{ 'Advance Filter' | countFilter(filter) }} </b-button>
					<span class="d-inline d-md-none">
						<b-button v-if="!isStacked" class="btn-action float-right btn-action-scroll" size="sm" @click="isStacked = true"><b-icon-view-stacked></b-icon-view-stacked></b-button>
						<b-button v-else class="btn-action float-right btn-action-scroll" size="sm" @click="isStacked = false"><b-icon-table></b-icon-table></b-button>
					</span>
					<span>
						<b-button :disabled="isPullRight" class="btn-action float-right btn-action-scroll" size="sm" @click="scrollRight"><b-icon-caret-right-fill></b-icon-caret-right-fill></b-button>
						<b-button :disabled="isPullLeft" class="btn-action float-right btn-action-scroll" size="sm" @click="scrollLeft"><b-icon-caret-left-fill></b-icon-caret-left-fill></b-button>
					</span>
				</div>

				<b-table-simple small stacked="md" head-variant="light" class="p-0 m-0" bordered hover :responsive="true">
					<b-thead v-if="wip">
						<b-th colspan="7">Inprocess</b-th>
					</b-thead>
					<b-thead head-variant="light" v-if="wip">
						<b-th style="width:20px">No</b-th>
						<b-th v-for="(itemTable, indexTable) in wip.columNames" :key="indexTable">{{ itemTable }}</b-th>
					</b-thead>
					<b-tbody v-if="wip">
						<b-tr v-for="(itemRow, indexRow) in wip.cellValues" :key="indexRow">
							<b-td>{{ indexRow + 1 }}</b-td>
							<b-td v-for="(itemCol, indexCol) in itemRow" :key="indexCol">{{ (indexCol > 0) ? Number(itemCol).toLocaleString() : itemCol }}</b-td>
						</b-tr>
					</b-tbody>

					<b-thead v-if="finishGood">
						<b-th colspan="7">Outgoing</b-th>
					</b-thead>
					<b-thead head-variant="light" v-if="finishGood">
						<b-th style="width:20px">No</b-th>
						<b-th v-for="(itemTable, indexTable) in finishGood.columNames" :key="indexTable">{{ itemTable }}</b-th>
					</b-thead>
					<b-tbody v-if="finishGood">
						<b-tr v-for="(itemRow, indexRow) in finishGood.cellValues" :key="indexRow">
							<b-td>{{ indexRow + 1 }}</b-td>
							<b-td v-for="(itemCol, indexCol) in itemRow" :key="indexCol">{{ (indexCol > 0) ? Number(itemCol).toLocaleString() : itemCol }}</b-td>
						</b-tr>
					</b-tbody>

					<b-thead v-if="rm">
						<b-th colspan="7">Incoming</b-th>
					</b-thead>
					<b-thead head-variant="light" v-if="rm">
						<b-th style="width:20px">No</b-th>
						<b-th v-for="(itemTable, indexTable) in rm.columNames" :key="indexTable">{{ itemTable }}</b-th>
					</b-thead>
					<b-tbody v-if="rm">
						<b-tr v-for="(itemRow, indexRow) in rm.cellValues" :key="indexRow">
							<b-td>{{ indexRow + 1 }}</b-td>
							<b-td v-for="(itemCol, indexCol) in itemRow" :key="indexCol">{{ (indexCol > 0) ? Number(itemCol).toLocaleString() : itemCol }}</b-td>
						</b-tr>
					</b-tbody>
				</b-table-simple>
			</div>

			<b-row v-if="false">
				<b-col cols="12" class="d-flex justify-content-center">
					<div>
						<b-row>
							<b-col cols="12">
								<b-pagination class="btn-paging paging-page-size"
											  v-model="currentPage"
											  :total-rows="(reportSummaryNgsPaging != null ? reportSummaryNgsPaging.dataCount : 0)"
											  :per-page="(reportSummaryNgsPaging != null ? reportSummaryNgsPaging.pageSize : 0)"
											  aria-controls="my-table">
									<template #first-text>
										<b-icon-chevron-left />
									</template>
									<template #prev-text>
										Prev
									</template>
									<template #next-text>
										Next
									</template>
									<template #last-text>
										<b-icon-chevron-right />
									</template>
								</b-pagination>
								<span class="paging-page-size">
									<b-form-select v-if="false" v-model="pageSizeOptions" size="sm" class="float-right" :options="pagingOptions"></b-form-select>
									<b-dropdown :text="pageSizeOptions + ' per page'" class="m-md-2 btn-paging-size" size="sm">
										<b-dropdown-item v-for="item in pagingOptions" :key="item.value" @click="pageSizeOptions = item.value">
											{{ item.text }}
										</b-dropdown-item>
									</b-dropdown>
								</span>
							</b-col>
						</b-row>
					</div>
				</b-col>
			</b-row>
		</div>
		<PopupDownload :openPopup="showPopupDownload"
            :processId="processId"
            @resetModalMethod="resetModal"
            label="Popup Download"
            :contentLabel="popupDownloadLabel" />
        <PopupPDF :openPopup="isShowPopupPDF"
            :pdfUrl="pdfUrl"
            @resetModalMethod="resetModal"
            label="Popup PDF" />
		<RouterView />
	</div>
</template><style lang="scss" scoped>
	@import '../../assets/scss/index-page.scss';

    

    ::v-deep #table-list-reportsummaryng.b-table.b-table-stacked > tbody > tr > td.th-front-action::before {
        background-image: url(/img/box-checklist.png);
        background-size: 40px 40px;
        display: block;
        width: 40px;
        height: 40px;
        content: "";
        margin-bottom: 10px;
    }

    ::v-deep #table-list-reportsummaryng.b-table.b-table-stacked > tbody > tr > td.th-front-action > div {
        display: flex;
    }
</style>
<script>
import ReportSummaryNG from '@/models/ReportSummaryNG/ReportSummaryNG';
import ReportSummaryNGList from '@/models/ReportSummaryNG/ReportSummaryNGList';
import ReportSummaryNGFilter from '@/filters/ReportSummaryNG/ReportSummaryNGFilter';
import RoleDetail from '@/models/Core/RoleDetail';
import AppInputDatepickerRange from '@/components/AppInputDatepickerRange';
import AppInputTextbox from '@/components/AppInputTextbox';
import AppInputComboboxAutocomplete from '@/components/AppInputComboboxAutocomplete';
import AppInputCombobox from '@/components/AppInputCombobox';
import PopupDownload from '@/components/PopupDownload';
import PopupPDF from '@/components/PopupPDF';
import PopupDataEditNotification from '@/components/PopupDataEditNotification';
import AppInputDatepicker from '@/components/AppInputDatepicker';

export default {
	components : {
		ReportSummaryNG, 
		ReportSummaryNGList, 
		ReportSummaryNGFilter, 
		AppInputTextbox,
		AppInputComboboxAutocomplete,
		AppInputCombobox,
		PopupDownload,
		PopupPDF,
		PopupDataEditNotification,
		AppInputDatepickerRange,
		AppInputDatepicker,
	},
	data() {
		return {
			selectAll:false,
			sortBy: '',
			sortDesc: '',
			pagingOptions:[
				{ value : '10', text : '10', selected:true },
				{ value : '25', text : '25' },
				{ value : '50', text : '50' },
				{ value : '100', text : '100' },
			],
			perPage: 10,
			currentPage: 1,
			totalData:0,
			fields: [
				{"no" : {"class" : "th-number d-stack-none"}},
				{"item": {}, "class" : "th-item first-child", "label" : "Item", key: 'item', }, 
				{"total": {}, "class" : "th-total", "label" : "Total", key: 'total', }, 
				{"m1": {}, "class" : "th-m1 last-child", "label" : "M1", key: 'm1', }, 
				{"m2": {}, "class" : "th-m2 d-stack-none", "label" : "M2", key: 'm2', }, 
				{"m3": {}, "class" : "th-m3 d-stack-none", "label" : "M3", key: 'm3', }, 
				{"m4": {}, "class" : "th-m4 d-stack-none", "label" : "M4", key: 'm4', }, 

			],
			yesNoCombo: [
				{ id : 'TRUE', name : 'True', selected:true },
				{ id : 'FALSE', name : 'False' },
			],
			busy:false,
			isDataLoading: false,
			isDownloadDataBusy: false,
			isMultiplePrintBusy: false,
			showPopupUpload: false,
			showPopupDownload: false,
			isShowPopupPDF: false,
			pdfUrl: "",
			selected:'',
			pageSizeOptions: 10,
			pageIndex:0,
			sortingBy: Array(),
			filter: null,
			processId: "",
			popupDownloadLabel: "",
			hasLoadedData: false,
			showFilter: false,
			isShowFilter: false,
			isCreateBusy: false,
			btnEditData: [],
			currentDataId: null,
			selectedModel: null,
			reportSummaryNgs: [],
			reportSummaryNgsPaging: {},

			isApprovalBusy: false,
			isFilterShow: false,
			isDeleteBusy: false,
			isPullRight: false,
			isPullLeft: true,
			isStacked: false,
			wip: [],
			rm: [],
			finishGood: [],
		}
	},	methods : {
		getReportSummaryNGs : async function() {
			this.isDataLoading = true;
			this.sortingBy = Array();
			if (this.sortBy != null) {
				this.sortingBy[this.sortBy] = this.sortDesc;
			}

			ReportSummaryNG.getList(this, this.filter, this.sortingBy, (this.currentPage - 1), this.pageSizeOptions)
			.then(result => {
				if (result != null) {
					this.reportSummaryNgs = result.data
					this.reportSummaryNgsPaging = result
					console.log(this.reportSummaryNgs[0]);
					this.wip = this.reportSummaryNgs[0].wip;
					this.rm = this.reportSummaryNgs[0].rm;
					this.finishGood = this.reportSummaryNgs[0].finishGood;
				}
				this.isDataLoading = false;
			})
			.catch(error => {
				this.isDataLoading = false;
			});
		},
		getReportSummaryNGsWithoutLoading : async function() {
			this.sortingBy = Array();
			if (this.sortBy != null) {
				this.sortingBy[this.sortBy] = this.sortDesc;
			}

			ReportSummaryNG.getList(this, this.filter, this.sortingBy, (this.currentPage - 1), this.pageSizeOptions)
			.then(result => {
				if (result != null) {
					this.reportSummaryNgs = result.data
					this.reportSummaryNgsPaging = result
					console.log(this.reportSummaryNgs[0]);
					this.wip = this.reportSummaryNgs[0].wip;
					this.rm = this.reportSummaryNgs[0].rm;
					this.finishGood = this.reportSummaryNgs[0].finishGood;
				}
			})
			.catch(error => {});
		},

		resetFilter() {
			this.filter = new ReportSummaryNGFilter();
			this.getReportSummaryNGs();
			this.isFilterShow = false;
		},
		showPopupUploadData() {
			this.showPopupUpload = true;
		},
		uploadData(modalEvent) {
			this.showPopupUpload = false;
		},
		resetModal() {
			this.showPopupUpload = false;
			this.showPopupDownload = false;
			this.isShowPopupPDF = false;
			this.isFilterShow = false;
		},
		resetModalUpload() {
			this.showPopupUpload = false;
			this.getReportSummaryNGs();
		},
		toggleSelect(id) {
			if (this.checkAllData.includes(id)) {
				this.$store.dispatch("removeCheckData", id);
			} else {
				this.$store.dispatch("addCheckData", id);
			}
		},
		showPopupPrint(id) {
			this.showPopupDownload = true;
			this.popupDownloadLabel = "Mempersiapkan data untuk di cetak";
			this.processId = id;
		},
		showPopupDownloadData(id) {
			this.showPopupDownload = true;
			this.popupDownloadLabel = "Mempersiapkan data untuk di unduh";
			this.processId = id;
		},
		showPopupPDF(url) {
			this.isShowPopupPDF = true;
			this.pdfUrl = url;
		},
		printData() {
			let data = this.$store.state.dataIds;
			if (data.length > 0) {
				this.isMultiplePrintBusy = true;
				ReportSummaryNG.multiPagePrint(this).then(result => {
					if (result) {
						this.showPopupPrint(result.id);
					}
				this.isMultiplePrintBusy = false;
				}).catch(error => { this.isMultiplePrintBusy = false; });
			}
		},
		printSingleData(id) {
			ReportSummaryNG.singleDataPagePrint(this, id).then(result => {
				if (result) {
					this.showPopupPDF(result.download);
				}
			});
		},
		downloadData() {
			this.isDownloadDataBusy = true;
			this.sortingBy = Array();
			if (this.sortBy != null) {
				this.sortingBy[this.sortBy] = this.sortDesc;
			}
			
			console.log('this.filter', this.filter);
			ReportSummaryNG.downloadData(this, this.filter, this.sortingBy)
			.then(result => {
				console.log('result ', result);
				if (result) {
					this.showPopupDownloadData(result.id);
				}
				this.isDownloadDataBusy = false;
			})
			.catch(error => { 
				this.isDownloadDataBusy = false; 
			})
		},

		deleteData(id) {
			ReportSummaryNG.deleteData(this, id).then(result => {
				if (result)
				{
					this.getReportSummaryNGs();
				}
			})
		},
		deleteMultipleData() {
			let data = this.$store.state.dataIds;
			if (data.length > 0) {
				this.isDeleteBusy = true;
				ReportSummaryNG.deleteMultipleData(this).then(result => {
					this.getReportSummaryNGs();
					this.isDeleteBusy = false;
				}).catch(error => { this.isDeleteBusy = false; });
			}
		},
		onResize() {
			this.windowWidth = window.innerWidth;
			if (this.windowWidth <= 576) {
				this.isStacked = true;
			} else {
				this.isStacked = false;
			}
		},
		displayFilter() {
			this.windowWidth = window.innerWidth;
			if (this.windowWidth <= 768) {
				this.isShowFilter = true;
			} else {
				this.isShowFilter = this.showFilter;
			}
		},


		scrollRight() {
			var tableReportSummaryNGParent = document.getElementById('table-list-reportsummaryng').parentNode;
			tableReportSummaryNGParent.scrollLeft += 250;
			this.isPullLeft = false;
			this.isPullRight = false;
			if ((tableReportSummaryNGParent.scrollWidth - tableReportSummaryNGParent.offsetWidth) == Math.ceil(tableReportSummaryNGParent.scrollLeft)) {
				this.isPullRight = true;
			}
		},
		scrollLeft() {
			var tableReportSummaryNGParent = document.getElementById('table-list-reportsummaryng').parentNode;
			tableReportSummaryNGParent.scrollLeft -= 250;
			this.isPullRight = false;
			this.isPullLeft = false;
			if (tableReportSummaryNGParent.scrollLeft <= 0) {
				this.isPullLeft = true;
			}
		},
		rowClass(item, type) {
			if (!item || type !== 'row') return
			if (this.checkAllData.includes(Number(item.id))) return 'item-active';
		}
	},
	beforeMount() {
		this.$store.dispatch("removeCheckAllData");
		this.filter = new ReportSummaryNGFilter();
	},
	mounted(){
		let breadcrumb =[
			"Master Data", 
			"Report Summary N G"
		];
		this.$store.dispatch('setBreadCrumb', breadcrumb);
		this.onResize();
		this.$nextTick(() => {
			this.getReportSummaryNGs();
			window.addEventListener('resize', this.onResize);
		});
	},	watch: {
		sortBy: {
			handler: function() {
				this.getReportSummaryNGs();
			}
		},
		sortDesc: {
			handler: function() {
				this.getReportSummaryNGs();
			}
		},
		currentPage: {
			handler: function() {
				this.getReportSummaryNGs();
			}
		},
		pageSizeOptions: {
			handler: function() {
				this.getReportSummaryNGs();
			}
		},
		selectAll(newValue) {
			if (newValue) {
				ReportSummaryNG.checkAllData(this, this.filter, this.sortingBy);
			} else {
				this.$store.dispatch("removeCheckAllData");
			}
		},
		'$route'(to, from) {
			if (to != null) {
				if (to.name == "reportsummaryngindex") {
					this.getReportSummaryNGsWithoutLoading();
				}
			}
		},
	},
	computed: {
		checkAllData() {
			return this.$store.state.dataIds;
		},
		userRole() {
			return RoleDetail.query().where("functionInfoId", "report_summary_n_g").first();
		},
		isShowDeleteButton : function() {
			let userRoleAllowDelete = true;
			if (this.userRole != null) {
				userRoleAllowDelete = this.userRole.allowDelete;
			}
			
			if (window.innerWidth <= 576) {
				if (userRoleAllowDelete) {
					if (this.checkAllData.length > 0) return true;
				}
				return false;
			}

			return userRoleAllowDelete;
		},
		isShowAdvanceFilterButton : function() {
			if (window.innerWidth <= 576) {
				if (this.checkAllData.length <= 0) return true;
				return false;
			}
			return true;
		}
	},	beforeDestroy() {
		this.$store.dispatch("removeCheckAllData");
	},
}
</script>
